import script from "./DashboardRightColumn.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardRightColumn.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardRightColumn.vue?vue&type=style&index=0&id=d805a402&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d805a402"]])

export default __exports__